import { createRouter, createWebHistory } from "vue-router";
import BasicRoutes from "./BasicRoutes.js";
import useUserStore from "@/store/userStore.js";
import usePermissionStore from "@/store/permissionStore.js";

const router = createRouter({
  history: createWebHistory(""),
  routes: BasicRoutes,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
  // scrollBehavior(to) {
  //   return to.hash ? { selector: to.hash, behavior: "smooth" } : { top: 0 };
  // },
});

const initialize = async (app) => {
  try {
    const userStore = useUserStore();
    const permissionStore = usePermissionStore();
    await userStore.initialize();
    await permissionStore.initialize();

    // 最后添加 404 路由
    router.addRoute({
      path: "/:catchAll(.*)*", // 注意这里的路径参数命名，确保它不会与你的其他路由冲突，例如使用`:catchAll(.*)*`来捕获所有路径。
      name: "NotFound",
      component: import("@/views/error/NotFound.vue"),
    });
    //
    router.addRoute({
      path: "",
      name: "NotFoundParent",
      component: () => import("@/layout/Layout.vue"),
      children: [
        {
          path: "/:pathMatch(.*)*",
          name: "NotFound",
          component: () => import("@/views/error/NotFound.vue"),
          meta: {
            id: "NotFound",
            componentName: "NotFound",
            keepAlive: true,
            name: "页面未找到",
          },
        },
      ],
    });
  } catch (e) {
    console.error(e);
  }

  app.use(router);
};

export { router, initialize };
